import { TotalCropReportTable, DivisionDetailReportTableContent } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const selectedSearchValues = this.props.selectedSearchValues;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;
        const inishialColumName = [{
            title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'left' }

        }]

        return (
            <div>
                <h3><center><u>Division Summary Detail Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {selectedSearchValues.group}</div>
                    <div className="col"><b>Estate: </b> {selectedSearchValues.estate}</div>
                    <div className="col"><b>From Date: </b> {selectedSearchValues.fromDate}</div>
                    <div className="col"><b>To Date: </b> {selectedSearchValues.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table id="totalCropPdf">
                        <thead>
                            <tr>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="3">Division<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="3">Field<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="12">Plucking Collection<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="4">Field Collection<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="4">Factory Collection<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="4">Field To Factory Varience<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="3">Checkroll To Factory Varience<br /></th>
                            </tr>
                            <tr>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">General<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">RSM<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">Cash<br /></th>
                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">Total<br /></th>
                            </tr>
                            <tr>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > NOB <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > NOB <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > NOB <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                            </tr>
                        </thead>
                        <tbody>
                            <DivisionDetailReportTableContent
                                data={data}
                                contentRowNames={rowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
                <hr />
            </div>
        );
    }
}